
module.service('AffnetReports', function($q, $injector, Report, AffnetReportDefinitions) {

    var overrides = {
        wage: {
            report: addWageOverride,
            container: WageDataContainer,
        }
    };

    // Affnet Base Report
    /////////////////////

    Report.makeChildClass(AffnetBaseReport);
    function AffnetBaseReport(program) {
        if (!this.$reportName)
            throw new Error("Must declare $reportName on affnet report prototype")

        if (!AffnetReportDefinitions[this.$reportName])
            throw new Error(this.$reportName + " is undefined");

        var url = ['reports/affnet', this.$reportName];
        if (program && program.id) url.push(program.id);
        if (this.$subUrl) url.push(this.$subUrl);

        Report.call(this, url);
    }

    defineGetters(AffnetBaseReport, {
        config: function() {
            return AffnetReportDefinitions[this.$reportName];
        },
        columns: function() { return this.config.columns; },
        $sorterConfig: function() {
            var columns = ['name'], i;
            for (i = 0; i < this.columns.length; i++) {
                columns.push(this.columns[i].name || 'metric');
            }
            return {
                default: this.$defaultSortColumn || 'name',
                direction: this.$defaultSortDirection || 'asc',
                columns: columns,
            };
        },
    });


    // Affnet Summary Report
    ////////////////////////

    AffnetBaseReport.extend(AffnetSummaryReport);
    addAffnetDataAccessors(AffnetSummaryReport, "data");
    function AffnetSummaryReport(program) {
        AffnetBaseReport.call(this, program);
    }


    // Affnet Details Report
    ////////////////////////

    AffnetBaseReport.extend(AffnetDetailsReport);
    AffnetDetailsReport.prototype.$subUrl = 'programs';
    AffnetDetailsReport.prototype.$isList = true;
    AffnetDetailsReport.prototype.$itemClass = AffnetDataContainer;
    function AffnetDetailsReport(program) {
        AffnetBaseReport.call(this, program);
    }


    // Affnet Students Report
    /////////////////////////

    AffnetBaseReport.extend(AffnetStudentsReport);
    AffnetStudentsReport.prototype.$subUrl = 'students';
    AffnetStudentsReport.prototype.$isList = true;
    AffnetStudentsReport.prototype.$itemClass = AffnetDataContainer;
    function AffnetStudentsReport(program) {
        AffnetBaseReport.call(this, program);
    }

    function AffnetReportGroup(name) {
        var group = this;
        this.$reportName = name;

        this.summary = makeAffnetReport(AffnetSummaryReport, name);
        this.details = makeAffnetReport(AffnetDetailsReport, name);
        this.students = makeAffnetReport(AffnetStudentsReport, name);

        if (overrides[name]) {
            if (overrides[name].container) {
                this.details.prototype.$itemClass = overrides[name].container;
                this.students.prototype.$itemClass = overrides[name].container;
            }
            if (overrides[name].report) {
                overrides[name].report(this.summary);
            }
        }
    }

    function AffnetReports(definitions) {
        for (var name in definitions) {
            this[name] = new AffnetReportGroup(name)
        }
    }

    AffnetReports.prototype.forMetric = function(metric, names, program) {
        var notFound = $q.reject({reason: 'notfound'}), reports = {}, i;
        if (!this[metric]) return notFound;

        if (names === 'all') names = ['summary', 'details', 'students'];

        for (i = 0; i < names.length; i++) {
            if (!this[metric][names[i]]) return notfound;
            reports[names[i]] = new this[metric][names[i]](program);
        }
        return new AffnetMultiReport(reports);
    };

    AffnetReports.prototype.forType = function(type, metrics, program) {
        var notFound = $q.reject({reason: 'notfound'}), reports = {}, i;
        if (['summary', 'details', 'students'].indexOf(type) === -1)
            return notfound;
        if (metrics === 'all') metrics = Object.keys(AffnetReportDefinitions);

        for (i = 0; i < metrics.length; i++) {
            if (!this[metrics[i]][type]) return notfound;
            reports[metrics[i]] = new this[metrics[i]][type](program)
        }
    };

    return new AffnetReports(AffnetReportDefinitions);
});


function AffnetMultiReport(reports) {
    this.reportNames = [];
    this.reports = [];
    for (var reportName in reports) {
        this.reportNames.push(name);
        this.reports.push(reports[reportName]);
        this[reportName] = reports[reportName];
    }
}


AffnetMultiReport.prototype.update = function(params) {
    for (var i = 0; i < this.reports.length; i++) {
        this.reports[i].update(params);
    }
};


function makeAffnetReport(BaseClass, name) {
    function AffnetReport(program) { BaseClass.call(this, program) };
    BaseClass.extend(AffnetReport);
    AffnetReport.prototype.$reportName = name;
    return AffnetReport;
}


function defineGetters(obj, getters) {
    for (var name in getters) {
        Object.defineProperty(obj.prototype, name, {
            enumerable: true,
            get: getters[name],
        });
    }
}


function AffnetDataContainer(obj) { angular.extend(this, obj); }
addAffnetDataAccessors(AffnetDataContainer);


function addAffnetDataAccessors(cls, dataObjectName) {

    function getData(obj) {
        return (dataObjectName ? obj[dataObjectName] : obj) || {};
    }

    cls.prototype.get = function(name, prefix) {
        var data = getData(this);
        return data[prefix ? prefix + "_" + name : name];
    }

    cls.prototype.getNumerator = prefixedGetter('numerator');
    cls.prototype.getDenominator = prefixedGetter('denominator');
    cls.prototype.getPercent = prefixedGetter('percent');
    cls.prototype.getMax = prefixedGetter("denominator_max");
    cls.prototype.getColor = prefixedGetter('affnet_color');
    cls.prototype.getLevel = prefixedGetter('affnet_level');

    defineGetters(cls, {
        color: function() { return getData(this).affnet_color; },
        affnetLevel: function() { return getData(this).affnet_level; },
    });
}

function WageDataContainer(obj) { AffnetDataContainer.call(this, obj); }
WageDataContainer.prototype = Object.create(AffnetDataContainer.prototype);
WageDataContainer.constructor = WageDataContainer;
addWageOverride(WageDataContainer);


function addWageOverride(cls) {

    var get = cls.prototype.get;
     cls.prototype.get = function(name, prefix) {
        var value = get.call(this, name, prefix);
        if (value && name === 'wage') {
            value = "$" + value.toFixed(2);
        }
        return value;
    }

    cls.prototype.getPercent = function(prefix) {
        return this.get('percent', prefix);
    }

    cls.prototype.getNumerator = function(prefix) {
        return this.getPercent(prefix);
    }

    cls.prototype.getDenominator = function(prefix) {
        return 100;
    }
}

function prefixedGetter(name) {
    return function(prefix) {
        return this.get(name, prefix);
    }
}
